export default {
    heading: `'GarageNeue', sans-serif`,
    body: `'GarageNeue', sans-serif`
}
